import { render, staticRenderFns } from "./StrapiEditoComponent.vue?vue&type=template&id=301de3de"
import script from "./StrapiEditoComponent.vue?vue&type=script&lang=js"
export * from "./StrapiEditoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports